import React, { useEffect, useState } from 'react';
import Icon from '../../../common/components/Icon';
import { t } from 'i18next';

import { getReviews } from '../../../api/get/getReviews';
import { getUserInfo } from '../../../api/usercall';

import default_image from '../../../assets/images/noimage.png';
import EmptyState from '../../../components/emptystate/EmptyState';

function MyReviewsContent({ setActiveTab }) {
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const userInfo = await getUserInfo();
                const user_id = userInfo?.user.id;
                if (!user_id) {
                    console.error('Пайдаланушы ID табылмады');
                    return;
                }
                const data = await getReviews({ user_id });
                const announcements = Array.isArray(data.announcements) ? data.announcements : [];
                setReviews(announcements);
            } catch (error) {
                console.error('Қате пайда болды:', error);
            }
        };
        fetchData();
    }, []);

    const handleBackClick = () => {
        if (typeof setActiveTab === 'function') {
            setActiveTab(null);
        }
    };

    return (
        <div className="p-4 max-w-4xl mx-auto">
            <Icon src="backicon" onClick={handleBackClick} className="w-6 h-6 mb-4 cursor-pointer" />
            <h2 className="text-xl font-bold text-gray-800 mb-6">{t('feedbacks')}</h2>
            
            {reviews.length === 0 ? (
                <EmptyState title={t('no_nothing')} subtitle={t('no_feedbacks')} />
            ) : (
                <div className="space-y-4">
                    {reviews.map((item) => (
                        <div key={item.id} className="flex bg-white rounded-lg p-4 items-center shadow-sm">
                            <img
                                src={item.main_image_url || default_image}
                                alt={item.title}
                                className="w-[213px] h-[160px] object-cover rounded-lg mr-6 flex-shrink-0"
                            />
                            <div className="flex-1">
                                <h3 className="text-base font-medium text-gray-800 mb-2">{item.title}</h3>
                                <p className="text-base font-bold text-[#147F26] mb-2">{item.price} тг.</p>
                                <div className="flex justify-between items-center bg-gray-100 rounded-lg p-2">
                                    <div className="flex items-center gap-2">
                                        <span className="font-semibold text-gray-800">{item.rating}</span>
                                        <img src="/star-icon.svg" alt="star" className="w-4.5 h-4.5" />
                                    </div>
                                    <span className="bg-[#147F26] text-white text-sm font-bold px-2 py-1 rounded-lg">
                                        {item.total_reviews}
                                    </span>
                                    <span className="text-sm text-gray-500">{item.created_at}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default MyReviewsContent;